import React from 'react'
import {funcPart, loadLazy} from 'uix/parts'

export const CapsuleConfig = loadLazy(() =>
  import(/* webpackChunkName: 'preservation' */ './capsule_config')
)
export const CapsuleReport = loadLazy(() =>
  import(/* webpackChunkName: 'preservation' */ './capsule_report')
)
export const CapsuleHistory = loadLazy(() =>
  import(/* webpackChunkName: 'preservation' */ './capsule_history')
)
export const CapsuleTitleList = loadLazy(() =>
  import(/* webpackChunkName: 'preservation' */ './capsule_title_list')
)
export const CapsuleList = loadLazy(() =>
  import(/* webpackChunkName: 'preservation' */ './capsule_list')
)
export const TransferInfo = loadLazy(() =>
  import(/* webpackChunkName: 'preservation' */ './transfer_info')
)
export const LocalCapsules = loadLazy(() =>
  import(/* webpackChunkName: 'preservation' */ './local_capsules')
)
export const CapsuleInfo = loadLazy(() =>
  import(/* webpackChunkName: 'preservation' */ './capsule_info')
)
